<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary" @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button class="button btn-danger"
                    v-if="this.element && this.element.id && getPermissionSection('delete')"
                    @click="openConfirmDelete = true">
                {{ $ml.get('buttons.delete') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <div class="block" :key="change">
            <div class="title">{{ pageTitle }}</div>
            <div class="body flex-row-wrap">
                <div class="w100">
                    <div class="formBlock">
                        <p class="label">Wide image (aspect ratio - 3x1)</p>
                        <div class="flex-row flex-row-image" style="align-items: center;">
                            <div class="avatar image-cover image-cover-top" :style="`flex-shrink:0; background-image: url(${image_preview.url ? image_preview.url : '/images/no_image.svg'});`"></div>
                            <div class="drag-in-drop"
                                 @dragover="dragoverFile"
                                 @dragleave="dragleaveFile"
                                 @drop="(e) => dropFile(e, 'image')"
                                 @click="$refs.image.click()">
                                <input type="file"
                                       @change="onChangeFile('image')"
                                       ref="image"
                                       accept=".jpeg,.jpg,.png,.gif" />
                                <div class="label">{{ lang.labels.drag_in_drop }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w100">
                    <div class="formBlock">
                        <p class="label">Small image (aspect ratio - 3x2)</p>
                        <div class="flex-row flex-row-image" style="align-items: center;">
                            <div class="avatar image-cover image-cover-bottom" :style="`flex-shrink:0; background-image: url(${image_small_preview.url ? image_small_preview.url : '/images/no_image.svg'});`"></div>
                            <div class="drag-in-drop"
                                 @dragover="dragoverFile"
                                 @dragleave="dragleaveFile"
                                 @drop="(e) => dropFile(e, 'image_small')"
                                 @click="$refs.image_small.click()">
                                <input type="file"
                                       @change="onChangeFile('image_small')"
                                       ref="image_small"
                                       accept=".jpeg,.jpg,.png,.gif" />
                                <div class="label">{{ lang.labels.drag_in_drop }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="w100">
                    <div class="formBlock">
                        <p class="label">Show in alerts</p>
                        <label>
                            <input type="checkbox" v-model="element.enable_notification" :disabled="element.notification_sent"> Enable
                        </label>
                        <p class="help" v-if="element.notification_sent"><b>Notification sent</b></p>
                    </div>
                </div>

                <div :class="getClass(label)"
                     v-for="(label, key) in labels">
                    <div class="formBlock">
                        <p :class="['label', {'required' : form_required.includes(label)}]">
                            {{ form_labels[label] }}
                            <template v-if="form_required.includes(label)">*</template>
                        </p>
                        <template v-if="getTypeForm(label) === 'number'">
                            <input type="number"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'boolean'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    v-model="element[label]"
                                    :options="selectBooleanOptions"
                                    :placeholder="form_labels[label]">
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'string'">
                            <div class="input disabled" v-if="element[label]">{{ element[label] }}</div>
                        </template>
                        <template v-if="getTypeForm(label) === 'date'">
                            <date-picker
                                type="datetime"
                                valueType="format"
                                format="MM/DD/YYYY HH:mm"
                                v-model="element[label]"
                                :placeholder="form_labels[label]"
                            />
                            <p class="help">Timezone: America/New York</p>
                        </template>
                        <template v-if="getTypeForm(label) === 'link'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'textarea'">
                            <textarea
                                class="textarea"
                                v-model="element[label]"
                                :placeholder="form_labels[label]">
                            </textarea>
                        </template>
                        <template v-if="getTypeForm(label) === 'input'">
                            <input type="text"
                                   class="input"
                                   v-model="element[label]"
                                   :placeholder="form_labels[label]">
                        </template>
                        <template v-if="getTypeForm(label) === 'select'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    :label="getSelectLabel(label)"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-tags'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    :value="element[label]"
                                    v-model="element[label]"
                                    :options="dictionaries[label]"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                        <template v-if="getTypeForm(label) === 'select-custom'">
                            <div class="defaultMultiselect">
                                <Multiselect
                                    track-by="id"
                                    label="title"
                                    :multiple="true"
                                    :taggable="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    v-model="element[label]"
                                    :options="dictionaries['categories']"
                                    :placeholder="form_labels[label]">
                                    <template slot="noResult">
                                        {{ $ml.get('interface.no_result') }}
                                    </template>
                                    <template slot="noOptions">
                                        {{ $ml.get('interface.no_options') }}
                                    </template>
                                </Multiselect>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="title">Description post</div>
            <div class="body">
                <Editor :api-key="api_editor" :init="config_editor" v-model="element.description" />
            </div>
        </div>



        <ModalWindow :open="openConfirmDelete"
                     @closeModal="openConfirmDelete = false">
            <template slot="title">
                {{ $ml.get('interface.confirm_action') }}
            </template>
            <template slot="body">
                {{ $ml.get('interface.confirm_action_delete') }}
            </template>
            <template slot="buttons">
                <button class="button btn-danger" @click="deleteForm">
                    {{ $ml.get('buttons.delete') }}
                </button>
            </template>
        </ModalWindow>

    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import FormMethodsDefault from "../../Utils/Page/Form/FormMethodsDefault";
import { quotePlugin } from '../../tinymce/plugins/quotePlugin/plugin.js';

export default {
    name: "Form",
    mixins: [FormMethodsDefault],
    components: {
        Editor
    },
    data() {
        let _this = this
        let selectors = 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img,audio,video'
        return {
            lang: this.$ml.get('pages.blog_post'),
            buttons: [
            ],

            typeForm: {
                categories: 'select-custom',
                published_at: 'date',
                visible: 'boolean',
                is_press: 'boolean',
                is_main: 'boolean',
                is_main_position: 'number',
            },

            form_required: [
                'title',
                'seo_description'
            ],

            element: {
                categories: [],
                published_at: null,
                enable_notification: false,
            },

            pageRouteList: 'blog_post',
            pageRouteEdit: 'blog_post.edit',
            pageApi: 'blog_post',
            pagePermission: 'blog.post',

            image_preview: {
                url: null,
            },
            image_small_preview: {
                url: null,
            },
            api_editor: '9ckshnlr5elbf2nk06c0s0vy3mr6ykx6o7fkmpxy4ndy5vkv',


            config_editor: {
                height: 500,
                menubar: false,
                setup: function () {
                    window.tinymce.PluginManager.add('quoteButton', quotePlugin);
                },
                formats: {
                    h2: { selector: 'h2', classes: 'h2', exact: true },
                    h3: { selector: 'h3', classes: 'h3', exact: true },
                    textMedium: { inline: 'span', classes: 'text-medium' },
                    textSmall: { inline: 'span', classes: 'text-small' },
                    textLarge: { inline: 'span', classes: 'text-large' },
                    textItalic: { inline: 'span', classes: 'text-italic' },
                    textUnderline: { inline: 'span', classes: 'text-underline' },
                    textLeft: { selector: selectors, classes: 'text-left' },
                    textCenter: { selector: selectors, classes: 'text-center' },
                    textRight: { selector: selectors, classes: 'text-right' },
                    textJustify: { selector: selectors, classes: 'text-justify' },
                    quote: { selector: 'div', classes: 'article-quote', exact: true },
                },
                style_formats_merge: false,
                style_formats: [
                    //{ title: 'Italic text', format: '' },
                    { title: 'Headers', items: [
                            { title: 'Header', block: 'h2', exact: true },
                            //{ title: 'Header 3', block: 'h3', exact: true },
                        ]
                    },
                    { title: 'Paragraph', items: [
                            { title: 'Paragraph small', block: 'p', exact: true,  classes: 'paragraph-small' },
                            { title: 'Paragraph', block: 'p', exact: true },
                            { title: 'Paragraph large', block: 'p', exact: true,  classes: 'paragraph-large' },
                        ]
                    },
                    { title: 'Block', items: [
                            { title: 'Block', block: 'div', exact: true },
                        ]
                    },
                    { title: 'Text', items: [
                            { title: 'Text small', format: 'textSmall' },
                            { title: 'Text medium', format: 'textMedium' },
                            { title: 'Text large', format: 'textLarge' },
                            { title: 'Text italic', format: 'textItalic' },
                            { title: 'Text underline', format: 'textUnderline' },
                        ]
                    },
                    { title: 'Align', items: [
                            { title: 'Left', format: 'textLeft' },
                            { title: 'Center', format: 'textCenter' },
                            { title: 'Right', format: 'textRight' },
                            { title: 'Justify', format: 'textJustify' },
                        ]
                    },

                    { title: 'Quote', block: 'div', classes: 'article-quote', exact: true },

                    { title: 'Image caption', block: 'div', classes: 'image-caption', exact: true },
                    { title: 'Checkmark list', selector: 'ul', classes: 'checkMarkList'},
                    { title: 'Dash list', selector: 'ul', classes: 'dashList'}
                ],

                content_style: `
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
                    p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,audio,video {
                        font-family: 'Inter', sans-serif;
                        font-size: 18px;
                        line-height: 1.67;
                        letter-spacing: normal;
                        color: #000;
                        margin-bottom: 24px;
                        font-weight: 300;
                        margin-top:0px;
                    }
                    a {
                        text-decoration: none;
                        color: #15a380;
                    }
                    a:hover{
                        text-decoration: underline;
                        color:#246356;
                    }
                    h2 {
                        font-size: 21px;
                        font-weight: 500;
                        margin-top: 40px;
                    }
                    h2:first-child{
                        margin-top:0px;
                    }
                    p{
                        margin-bottom: 40px;
                    }
                    p:last-child{
                        margin-bottom: 0px;
                    }
                    img{
                        margin-top: 24px;
                        margin-bottom:24px;
                    }
                    ul{
                        margin-bottom: 40px;
                    }
                    ul:last-child{
                        margin-bottom: 0;
                    }
                    ul {
                        margin-left: 16px;
                        list-style-type: disc;
                        padding-left:0;
                    }
                    ul li {
                        margin-bottom: 13px;
                        color:black;
                    }
                    ul li::marker {
                        color:#15a380;
                    }
                    ul li:last-child{
                        margin-bottom: 0;
                    }
                    ul li span, ol li span{
                        color:black;
                    }
                    ul li a span, ol li a span{
                        text-decoration: none;
                        color:#15a380;
                    }
                    ul li a:hover{
                        text-decoration: underline;
                    }
                    ol {
                        margin-left: 16px;
                        padding-left:0;
                    }
                    ol li {
                        list-style: decimal;
                        margin-bottom: 10px;
                    }
                    .image-caption{
                        font-size: 13px;
                        margin-top:-54px;
                        margin-bottom: 40px;
                        font-style: italic;
                    }
                    .dashList{
                        list-style-type: none !important;
                        list-style-position: inside;
                        color:black;
                        margin-left: 0;
                    }
                    .dashList li{
                        color:black;
                    }
                    .dashList li:before{
                        content: '- ';
                        display: inline-block;
                        margin-right: 10px;
                    }
                    .checkMarkList{
                        list-style-image: url(/images/success.svg) !important;
                        color:black;
                    }
                    .checkMarkList li{
                        color:black;
                    }
                    .paragraph-small { font-size: 12px; }
                    .paragraph-large { font-size: 20px; }
                    .text-underline { text-decoration: underline; }
                    .text-italic { font-style: italic; }
                    .text-small { font-size: 12px; }
                    .text-medium { font-size: 17px; }
                    .text-large { font-size: 20px; }
                    .text-left { text-align: left; }
                    .text-center { text-align: center; }
                    .text-right { text-align: right; }
                    .text-justify { text-align: justify; }
                    .article-quote {
                        position: relative;
                        padding: 40px 110px 40px 40px;
                        background-color: #f8f6f4;
                        font-family: $font-main;
                        font-size: 24px;
                        font-weight: 300;
                        font-stretch: normal;
                        font-style: italic;
                        line-height: 1.33;
                        letter-spacing: normal;
                        color: #000;
                        margin:40px 0;
                    }
                    .article-quote:first-child{
                        margin-top:0;
                    }
                    .article-quote:last-child{
                        margin-bottom:0;
                    }
                    .article-quote-content {
                        margin-bottom: 0;
                    }

                    .article-quote:after {
                        position: absolute;
                        top: 40px;
                        right: 40px;
                        display: block;
                        text-align: center;
                        font-style: normal;
                        font-size: 42px;
                        margin-left: 10px;
                        font-family: "artifcts" !important;
                        content: '\E921';
                    }
                `,
                plugins: [
                    'advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                    'image imagetools',
                    'quoteButton',
                    'media',
                ],
                media_live_embeds: true,
                toolbar:
                    'undo redo | styleselect | backcolor forecolor | image | media | \
                    alignleft aligncenter alignright alignjustify | \
                    link bullist numlist outdent indent | removeformat | help fullscreen code',
                imagetools_toolbar: 'rotateleft rotateright | flipv fliph | editimage imageoptions',
                //image_advtab: true,
                //automatic_uploads: true,
                //document_base_url : "/",
                file_picker_types: 'image',
                image_title: true,
                images_upload_base_path: '/',
                relative_urls : false,
                remove_script_host : true,
                images_upload_handler: function (blobInfo, success, failure) {
                    let formData = new FormData();
                    formData.append('image', blobInfo.blob(), blobInfo.filename());
                    axios.post(_this.$store.getters.getApiUrl('blog_post_upload_image'), formData)
                        .then(({data}) => {
                            success(data.location);
                        })
                        .catch((e) => {
                            failure('HTTP Error: ' + e.status);
                        })
                },
            }

        }
    },
    computed: {
        //config_editor() { return tinymceConfig.config; }
    },
    methods: {
        saveForm() {
            let access = false
            if (this.id) {
                access = this.getPermissionSection('edit')
            } else {
                access = this.getPermissionSection('create')
            }
            if (!access) {
                this.$store.commit('setNotification', {
                    type: 'error',
                    message: 'Permission denied'
                })
                return;
            }


            let data = {
                element: {},
            }

            for (let key in this.element) {
                if (this.form_required.includes(key) && !this.element[key]) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.$ml.get('interface.empty_field') + ' - ' + this.lang.form[key]
                    })
                    return
                }

                data.element[key] = this.element[key]
                if (this.selectKeys.includes(this.getTypeForm(key))) {
                    this.getValueSelect(data.element, key)
                }
                if (this.getTypeForm(key) === 'boolean') {
                    if (this.element[key]) {
                        data.element[key] = this.element[key].id
                    }
                }
            }
            let form = new FormData()
            if (this.image_preview.file) {
                form.append('image', this.image_preview.file)
            }
            if (this.image_small_preview.file) {
                form.append('image_small', this.image_small_preview.file)
            }
            form.append('element', JSON.stringify(data.element))


            this.$store.commit('setLoading', true)
            axios.post(this.$store.getters.getApiUrl(this.pageApi), form)
                .then(({data}) => {
                    if (data.success) {
                        if (!this.id) {
                            this.id = data.element.id
                            this.$router.push({name: this.pageRouteEdit, params: {id: data.element.id}})
                        }
                        this.getData()
                        this.$store.commit('setNotification', {
                            type: 'success',
                            message: this.$ml.get('interface.saved')
                        })
                    } else {
                        this.$store.commit('setErrorMessage', data.message)
                    }
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        getClass(key) {
            if (key === 'title' || /seo_/.test(key)) {
                return 'w100'
            }
            return 'w33'
        },
        setExtraData(data) {
            this.image_preview.url = data.element.image
            this.image_small_preview.url = data.element.image_small
        },
        // Событие при перетаскивании файла
        dragoverFile(event) {
            event.preventDefault();
            event.currentTarget.classList.add('over');
        },
        // Событие при убирании курсора при перетаскивании
        dragleaveFile(event) {
            event.currentTarget.classList.remove('over');
        },
        // Событие добавления файла
        dropFile(event, type) {
            // Снимаем стиль
            event.currentTarget.classList.remove('over')
            event.preventDefault()
            // Помещаем изображение в input
            if (type === 'image') {
                this.$refs.image.files = event.dataTransfer.files
            }
            if (type === 'image_small') {
                this.$refs.image_small.files = event.dataTransfer.files
            }
            // Вызываем событие изменения
            this.onChangeFile(type)
        },
        // Изменение при добавлении файла
        onChangeFile(type) {
            let files = []
            if (type === 'image') {
                files = this.$refs.image.files
            }
            if (type === 'image_small') {
                files = this.$refs.image_small.files
            }
            files = Array.from(files)
            files.map(file => {
                if (!this.acceptFile(file, type)) {
                    this.$store.commit('setNotification', {
                        type: 'error',
                        message: this.lang.labels.file_error.replace( /{f}/, file.name)
                    })
                } else {
                    let key = 'upload_' + Math.abs(Math.ceil(Math.random() * (1000 - 9999) + 1000))
                    if (type === 'image' || type === 'image_small') {
                        let item = {
                            url: '',
                            file: file,
                        }
                        let reader = new FileReader();
                        reader.onload = (e) => {
                            item.url = e.target.result
                        }
                        reader.readAsDataURL(file);
                        if (type === 'image') {
                            this.image_preview = item
                        }
                        if (type === 'image_small') {
                            this.image_small_preview = item
                        }
                    }
                }
            })
        },
        acceptFile(file, type) {
            let accept_images = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
            ]
            let accept_document = [
                'image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/svg+xml',
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ];
            if (type === 'image' || type === 'image_small') {
                if (!accept_images.includes(file.type)) {
                    return false
                }
            } else {
                if (!accept_document.includes(file.type)) {
                    return false
                }
            }
            return true
        },
    }
}
</script>

<style scoped>

</style>
